import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TicketMaintenanceParameters } from "../models/TicketMaintenanceParameters";
import { TicketMaintenanceLoadItem } from "../models/TicketMaintenanceLoadItem";


@Injectable({
    providedIn: 'root'
})
export class TicketMaintenanceService {


    constructor(private http: HttpClient) {
    }


    getLoadsForTicketMaintenance(parms: TicketMaintenanceParameters): Observable<any> {
        return this.http.post<TicketMaintenanceLoadItem[]>('api/ticketmaintenance/getloads/', parms)
    }

    updatePA(loadIds: number[]): Observable<boolean> {
        return this.http.post<boolean>('api/ticketmaintenance/updatePA', loadIds);
    }

    updateFS(loadIds: number[]): Observable<boolean> {
        return this.http.post<boolean>('api/ticketmaintenance/updateFS', loadIds);
    }

    updateDlvd(loadIds: number[]): Observable<boolean> {
        return this.http.post<boolean>('api/ticketmaintenance/updateDlvd', loadIds);
    }

    updateDeliveredDate(loadIds: number[], deliveredDate: string): Observable<boolean> {
        return this.http.post<boolean>('api/ticketmaintenance/updateDeliveredDate', {
            "LoadIds": loadIds,
            "deliveredDate": deliveredDate
        });
    }

    saveLoadTM(params: { maNotes: string; notes: string; ticketNumber: string; loadId: number; }) {      
        return this.http.post<boolean>('api/ticketmaintenance/saveLoadTM', params);
    }
}